import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import GujaratMapIndia from './GujaratMapInteractive'; // Import the new component
import { useSelector } from "react-redux";

interface GujaratMapProps{
  hlanguage:any;
}

const GujaratMap: React.FC<GujaratMapProps> = ({hlanguage}) => {
    // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);

    return (
        <div
            className="m-auto w-100"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/img/home_MAP.svg)`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                minHeight: "60vh",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px 0",
            }}
        >
            <div className="container">
                <div className="row justify-content-center align-items-center g-4">
                    {/* Left Text Column */}
                    <div className="col-12 col-md-6 col-lg-7">
                        <div
                            style={{
                                height: "400px", 
                                minHeight: "60vh",
                                width: "100%",
                                // backgroundColor: "white",
                                borderRadius: '15px',
                                overflow: "visible",
                                padding: "20px"
                            }}
                        >
                            <GujaratMapIndia />
                        </div>
                    </div>
                    {/* Right Text Column */}
                    <div className="col-12 col-md-6 col-lg-5">
                        <h4
                            className="mb-3"
                            style={{
                                color: "white",
                                fontSize: "clamp(1.25rem, 4vw, 2rem)",
                                fontWeight: "bold",
                                letterSpacing: "1px",
                                lineHeight: "1.2",
                            }}
                            >
                            {hlanguage?.g_map_1}
                            <br />
                            {hlanguage?.g_map_2}
                            <br />
                            {hlanguage?.g_map_3}
                        </h4>
                        <p
                            style={{
                                color: "white",
                                fontSize: "clamp(0.9rem, 2.5vw, 1.2rem)",
                                letterSpacing: "1px",
                                lineHeight: "1.2",
                            }}
                            >
                            {hlanguage?.g_map_4}
                            <br />
                            {hlanguage?.g_map_5}
                        </p>
                    </div> 

                </div>
            </div>
        </div>
    );
};

export default GujaratMap;